import { TpvUnitListItem, UnitCreatedResult } from '@app/domain/models/tpv/unit.model';
import { UnitListItemDto, CreateUnitResponseDto } from '@app/data/dtos/tpv/unit.dto';

/** Mapea un item del listado de unidades al modelo de dominio. */
export function mapUnitListItem(dto: UnitListItemDto): TpvUnitListItem {
  return {
    idUnit: dto.external_id_unit ?? dto.id_unit ?? '',
    isPrimary: dto.is_primary === true,
    name: dto.name ?? '',
    status: dto.status ?? '',
  };
}

/** Mapea la respuesta de creación de unidad; el id puede venir como external_id_unit o id_unit. */
export function mapUnitCreated(dto: CreateUnitResponseDto): UnitCreatedResult {
  return {
    idUnit: dto.external_id_unit ?? dto.id_unit ?? '',
    isPrimary: dto.is_primary,
    name: dto.name,
    status: dto.status,
  };
}
